"use strict";
/**
 * @module Services.MissingTopic
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_selector_serialiser_1 = require("./../../topics/topic-selector-serialiser");
var missing_topic_request_1 = require("./missing-topic-request");
/**
 * Serialiser for {@link MissingTopicRequest}
 */
var MissingTopicRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MissingTopicRequestSerialiserClass, _super);
    function MissingTopicRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link MissingTopicRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link MissingTopicRequest} that was read
     */
    MissingTopicRequestSerialiserClass.prototype.read = function (bis) {
        var selector = topic_selector_serialiser_1.TopicSelectorSerialiser.read(bis);
        var properties = Codec.readDictionary(bis, Codec.readString);
        var serverNames = Codec.readCollection(bis, Codec.readString);
        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
        return new missing_topic_request_1.MissingTopicRequest(selector, properties, serverNames, cid);
    };
    /**
     * Write a {@link MissingTopicRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link MissingTopicRequest} to be written
     */
    MissingTopicRequestSerialiserClass.prototype.write = function (bos, value) {
        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
        Codec.writeDictionary(bos, value.sessionProperties, Codec.writeString);
        Codec.writeCollection(bos, value.serverNames, Codec.writeString);
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
    };
    return MissingTopicRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MissingTopicRequestSerialiserClass = MissingTopicRequestSerialiserClass;
/**
 * The {@link MissingTopicRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.MissingTopicRequestSerialiser = new MissingTopicRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/missing-topic/missing-topic-request-serialiser.js
// module id = 1597
// module chunks = 1